import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ConfigProvider, theme } from 'antd';
import "./styles/App.css";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import HomeReal from "./pages/Home";
import HomeConstruction from "./pages/HomeConstruction";
import Domoelec from "./pages/Domoelec";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import BrandPromotion from "./pages/BrandPromotion";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

// Admin
import AdminApp from "./admin/App";

function App() {
  return (
    <AuthProvider>
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: { colorPrimary: '#1677ff' }
        }}
      >
        <Router>
        <div className="App">
          <Routes>
            {/* Redirect legacy /dashboard to admin dashboard */}
            <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />

            {/* Routes d'authentification */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Routes protégées admin */}
            <Route path="/admin/*" element={
              <ProtectedRoute requiredRole="editor">
                <AdminApp />
              </ProtectedRoute>
            } />
            
            {/* Page en construction - sans header/footer */}
            <Route path="/" element={<HomeConstruction />} />

            {/* Routes du site principal */}
            <Route path="/*" element={
              <>
                <Header />
                <main>
                  <Routes>
                    <Route path="/domoelec" element={<Domoelec />} />
                    <Route path="/produits" element={<Products />} />
                    <Route path="/produit/:slug" element={<ProductDetail />} />
                    <Route path="/promotion-marque/:brandName" element={<BrandPromotion />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/contact" element={<Contact />} />
                  </Routes>
                </main>
                <Footer />
                <Chatbot />
              </>
            } />
          </Routes>
        </div>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
